import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from '../../../../../store/utility';
import { backend_server_address } from '../../../../../backendServer';

export const mediaAPI = createApi({
    reducerPath: 'mediaAPI',
    baseQuery: axiosBaseQuery({ baseUrl: backend_server_address + '/api/v2/media/' }),
    tagTypes: ['MediaList'],
    endpoints: (builder) => ({
        getMediaList: builder.query({
            query: (params) => {
                return {
                    url: ``,
                    method: 'GET',
                    withCredentials: true,
                    params,
                };
            },
            providesTags: (result, error, { node_id }) => [{ type: 'MediaList', id: node_id }],
        }),
        uploadMediaFile: builder.mutation({
            query: (data) => {
                return {
                    url: ``,
                    method: 'POST',
                    withCredentials: true,
                    data,
                };
            },
            invalidatesTags: (result, error, { node_id }) => [{ type: 'MediaList', id: node_id }],
        }),
    }),
});

export const { endpoints, useGetMediaListQuery, useUploadMediaFileMutation } = mediaAPI;

export const mediaAPIReducer = mediaAPI.reducer;
export const mediaAPIReducerPath = mediaAPI.reducerPath;
export const mediaAPIReducerMiddleware = mediaAPI.middleware;
